import { dataMappingsMockData, externalTemplatesMockData } from '../dataMapping/constants';
import { addFieldPrefix } from '../utils';
import { DataMappingValues } from '../dataMapping/DataMappingForm';
import { TemplateOptionsValues } from '../TemplatesOptionsForm';
import { TemplateFormValues } from '../types';

export const useInitialValues = (): TemplateFormValues => {
    const dataMappingData = dataMappingsMockData;
    const externalTemplatesData = externalTemplatesMockData[0];

    const templateOptionsFields: TemplateOptionsValues = {
        name: externalTemplatesData.name,
        description: externalTemplatesData.description,
        services: externalTemplatesData.serviceIds,
        template: externalTemplatesData.docusignTemplateId,
    };

    const dataMappingFields = dataMappingData
        .filter((field) => field.tabType === 'text')
        .reduce(
            (acc: DataMappingValues, field) => ({
                ...acc,
                [addFieldPrefix(field.tabId)]: field.valueIdentifier,
            }),
            {}
        );

    return {
        templateOptionsFields,
        dataMappingFields,
    };
};
